import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import AboutUsSiteInnerContainer from 'components/about-us/AboutUsSiteInnerContainer';
import YourWins from 'components/dashboard/your-wins/YourWins';
import { isLoadedPrizeWins, TPrizeDisplayItem } from 'constants/WinType';
import { useEffect, useState } from 'react';
import { TClaimedPrizeWins, TUnclaimedPrizeWins } from 'stores/UserStore';
import { DaymadeDesignSystemPreviewComponentInfo } from '.';

const unclaimedPrizeWins = [
  {
    id: '5a146179-703e-4429-b7e3-ea4619680ac4',
    ticketEntryId: '5165759d-bd86-46f0-a169-e1f5eee8cc2e',
    status: 'PENDING',
    prizeTierId: 2,
    createdAt: new Date('2026-02-03T17:03:00.305Z'),
    gameType: 'LOTTERY',
    prizeStructureCode: 'DMDP',
    prizeTierCode: 'Treat1',
    prizeTierType: 'IN_GAME',
    drawId: 233,
    drawName: 'Weekly Tuesday Draw',
    expiresAt: new Date('2026-03-05T17:03:00.307Z'),
    drawPrizeId: null,
    drawPrizeSlug: null,
    drawPrizeTitle: null,
    drawPrizeSubheading: null,
    drawPrizeImageLocation: null,
  },
  {
    id: '43de3a25-c338-404a-8be4-b92d1b4ae6cf',
    ticketEntryId: 'b6e1370f-b1bc-4065-bf24-76ec6a496271',
    status: 'PENDING',
    prizeTierId: 2,
    createdAt: new Date('2026-03-03T17:03:00.093Z'),
    gameType: 'LOTTERY',
    prizeStructureCode: 'DMDP',
    prizeTierCode: 'Treat1',
    prizeTierType: 'IN_GAME',
    drawId: 390,
    drawName: 'Weekly Tuesday Draw',
    expiresAt: new Date('2026-03-31T16:03:00.095Z'),
    drawPrizeId: null,
    drawPrizeSlug: null,
    drawPrizeTitle: null,
    drawPrizeSubheading: null,
    drawPrizeImageLocation: null,
  },
] as TUnclaimedPrizeWins;

const claimedPrizeWins = [
  {
    id: '35065b1d-d476-40ce-96f8-2112e87c4259',
    ticketEntryId: 'f1f3fb5a-751e-48e0-8737-24d5066845cd',
    status: 'AWARDED',
    prizeTierId: 2,
    createdAt: new Date('2026-03-10T17:03:00.350Z'),
    gameType: 'LOTTERY',
    prizeStructureCode: 'DMDP',
    prizeTierCode: 'Treat1',
    prizeTierType: 'IN_GAME',
    drawId: 420,
    drawName: 'Weekly Tuesday Draw',
    chosenAt: new Date('2026-03-20T10:46:55.300Z'),
    chosenPrizeId: 619,
    chosenPrizeName: '1 DAYMADE Token',
    chosenPrizeDescription: 'Exchangeable for free entries, prizes and more',
    chosenPrizeImageLocation:
      'https://prize-assets.daymade.co.uk/880f8baf-8d18-464e-9e74-4ec090834847.jpg',
    chosenPrizeProducts: [
      {
        id: 1,
        name: 'DAYMADE Token',
        autoFulfilmentCode: 'DAYMADE_TOKEN',
        prizeOrderProductId: 'a957747b-228c-4354-8c23-87dcf42dd472',
      },
    ],
    isChosenByPlayer: true,
    feedbackRating: null,
    feedbackComment: null,
  },
] as TClaimedPrizeWins;

const ComponentPreview = () => {
  const [allWins, setAllWins] = useState<TPrizeDisplayItem[]>([]);

  useEffect(() => {
    const allWins: TPrizeDisplayItem[] = [
      ...(isLoadedPrizeWins(unclaimedPrizeWins)
        ? unclaimedPrizeWins
            .filter(
              (win) =>
                'expiresAt' in win &&
                win.expiresAt &&
                win.expiresAt > new Date(),
            )
            .sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime(),
            )
        : []),
      ...(isLoadedPrizeWins(claimedPrizeWins)
        ? claimedPrizeWins.sort(
            (a, b) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
          )
        : []),
    ];

    setAllWins(allWins);
  }, []);

  return (
    <AboutUsModule background={'grey'}>
      <AboutUsSiteContainer>
        <div style={{ marginBottom: 24 }}>
          <h3 className="aboutUsTypographyHeaderLarge">Your Wins </h3>
          <p>
            <>
              The Your Wins component, as used on the dashboard. It displays the
              user's wins, with the most recent win at the top.
            </>
          </p>
        </div>
        <AboutUsSiteInnerContainer background="white" borderRadius withPadding>
          <YourWins
            unclaimedPrizeWins={unclaimedPrizeWins}
            allWins={allWins}
            getPrizeWins={() =>
              new Promise<void>(() => {
                return;
              })
            }
          />
        </AboutUsSiteInnerContainer>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Your Wins',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
